<template>
  <div class="create-team-name">
    <div class="create-modal-group-name-content">群名称</div>
    <div class="create-modal-group-name-input">
      <el-input v-model="localTeamName" placeholder="请输入群名称" maxlength="30" size="mini"></el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateTeamName',
  components: {
  },
  props: {
    teamName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      localTeamName: this.teamName
    }
  },
  computed: {
  },
  watch: {
    localTeamName (newVal) {
      this.$emit('update:teamName', newVal)
    },
    teamName (newVal) {
      this.localTeamName = newVal
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  .create-team-name {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 15px 0;
  }
  .create-modal-group-name-content {
    width: 80px;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .create-modal-group-name-input {
    width: 260px;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/team/create/CreateTeamName.vue